import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OSStructuringMethods = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Structuring Methods: Monolithic, Layered, Modular, Microkernel Models"
    videos={[
      "https://www.youtube.com/embed/D262QFTj9mw"
    ]}
    takeaways={[]}
    questions={[
      "Describe the various methods used for operating system structure. Also discuss the advantages and disadvantages of each structuring method.",
      "Explain Monolithic and Layered system of Operating System Structure.",
      "Compare layered approach and micro-kernel approach of OS structuring models. Discuss the merits and demerits of each approach.",
      "A Computer system can have a single processor, multiprocessor, and multicore processor architecture. A job or program can be executed either sequentially or in parallel based on its design. Enumerate the advantages of having different system architectures and analyze the effect of executing a set of jobs run in sequential or parallel over these architectures.",
      "Evaluate the main advantage of the microkernel approach to system design. Furthermore, analyze how user programs and system services interact within a microkernel architecture. Finally, assess the disadvantages associated with using the microkernel approach.",
      "Evaluate the use of monolithic kernels in real-time scenarios compared to microkernels. In your analysis, discuss specific situations where a monolithic kernel may be preferred and critically assess its advantages over microkernels. Additionally, explore the mechanisms of interaction between user programs and system services in a monolithic architecture, while also considering the potential disadvantages of this approach. How might these factors influence the choice of kernel design in modern operating systems?"
    ]}
    exampleVideos={[]}
  />
);
}

export default OSStructuringMethods;
